export interface IEncryptionDriver {
  encrypt(text: string, password: string): string;
  decrypt(text: string, password: string): string;
  getSha256HashBase64(text: string): string;
}
